<template>
    <div class="container pt-2">
        <PageTitle main="Meus Dados" sub="Alteração dos seus dados" />
        <b-form>
            <input id="funcionario-id" type="hidden" v-model="funcionario.id" />
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Nome:" label-for="funcionario-nome">
                        <b-form-input id="funcionario-nome" type="text"
                            v-model="funcionario.nome"
                            placeholder="Informe o Nome do funcionario."
                            :class="{ 'inputError': $v.funcionario.nome.$error }"
                            class="textInput"
                            @keydown.tab="$v.funcionario.nome.$touch"/>
                        <span class="error" v-if="!$v.funcionario.nome.required && $v.funcionario.nome.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.nome.minLength && $v.funcionario.nome.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <b-form-group label="Telefone:" label-for="funcionario-telefone">
                        <b-form-input id="funcionario-telefone" type="tel"
                            v-model="funcionario.telefone"
                            placeholder="Informe o telefone do funcionario."
                            v-mask="['(##)####-####', '(##)#####-####']"
                            :class="{ 'inputError': $v.funcionario.telefone.$error }"
                            class="textInput"
                            @keydown.tab="$v.funcionario.telefone.$touch"/>
                        <span class="error" v-if="!$v.funcionario.telefone.required && $v.funcionario.telefone.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.telefone.minLength && $v.funcionario.telefone.$error">Digite um telefone válido!</span>
                    </b-form-group>
                </div>
                <div class="col-md-5">
                    <b-form-group label="E-mail:" label-for="funcionario-email">
                        <b-form-input id="funcionario-email" type="email"
                            v-model="funcionario.email"
                            placeholder="Informe o E-mail do funcionario."
                            :class="{ 'inputError': $v.funcionario.email.$error }"
                            class="textInput"
                            @keydown.tab="$v.funcionario.email.$touch"/>
                        <span class="error" v-if="!$v.funcionario.email.required && $v.funcionario.email.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.email.email && $v.funcionario.email.$error">Digite um email válido!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="CEP:" label-for="funcionario-cep">
                        <b-form-input id="funcionario-cep" type="text"
                            v-model="funcionario.cep"
                            placeholder="CEP"
                            :class="{ 'inputError': $v.funcionario.cep.$error }"
                            class="textInput"
                            v-mask="'#####-###'"
                            @keydown.tab="searchCep"/>
                        <span class="error" v-if="!$v.funcionario.cep.required && $v.funcionario.cep.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.cep.minLength && $v.funcionario.cep.$error">Digite um CEP válido!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Ativo:" label-for="funcionario-ativo">
                        <b-form-select id="funcionario-ativo" :options="ativar" v-model="funcionario.ativo" 
                        :class="{ 'inputError': $v.funcionario.ativo.$error }"
                        class="textInput"
                            @keydown.tab="$v.funcionario.ativo.$touch"/>
                        <span class="error" v-if="!$v.funcionario.ativo.required && $v.funcionario.ativo.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Motorista:" label-for="funcionario-motorista">
                        <b-form-select id="funcionario-motorista" :options="ListaMotorista" v-model="funcionario.motorista"
                        @change="showMotorista"
                        :class="{ 'inputError': $v.funcionario.motorista.$error }"
                        class="textInput"
                            @keydown.tab="$v.funcionario.motorista.$touch"/>
                        <span class="error" v-if="!$v.funcionario.motorista.required && $v.funcionario.motorista.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <b-form-group label="Cidade:" label-for="funcionario-cidade">
                        <b-form-input id="funcionario-cidade" type="text"
                            v-model="funcionario.cidade"
                            placeholder="Informe o Cidade do funcionario."
                            :class="{ 'inputError': $v.funcionario.cidade.$error }"
                            class="textInput"
                            @keydown.tab="$v.funcionario.cidade.$touch"/>
                        <span class="error" v-if="!$v.funcionario.cidade.required && $v.funcionario.cidade.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="UF:" label-for="funcionario-UF">
                        <b-form-select id="funcionario-UF" :options="ufs" v-model="funcionario.uf" 
                        :class="{ 'inputError': $v.funcionario.uf.$error }"
                        class="textInput"
                            @keydown.tab="$v.funcionario.uf.$touch"/>
                        <span class="error" v-if="!$v.funcionario.uf.required && $v.funcionario.uf.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Logradouro:" label-for="funcionario-logradouro">
                        <b-form-input id="funcionario-logradouro" type="text"
                            v-model="funcionario.logradouro"
                            placeholder="Informe o logradouro do funcionario."
                            :class="{ 'inputError': $v.funcionario.logradouro.$error }"
                            class="textInput"
                            @keydown.tab="$v.funcionario.logradouro.$touch"/>
                        <span class="error" v-if="!$v.funcionario.logradouro.required && $v.funcionario.logradouro.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.logradouro.minLength && $v.funcionario.logradouro.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-1">
                    <b-form-group label="Número:" label-for="funcionario-numero">
                        <b-form-input id="funcionario-numero" type="text"
                            v-model="funcionario.numero"
                            placeholder="Nº"
                            :class="{ 'inputError': $v.funcionario.numero.$error }"
                            class="textInput"
                            @keydown.tab="$v.funcionario.numero.$touch"/>
                        <span class="error" v-if="!$v.funcionario.numero.required && $v.funcionario.numero.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Complemento:" label-for="funcionario-complemento">
                        <b-form-input id="funcionario-complemento" type="text"
                            v-model="funcionario.complemento"
                            class="textInput"/>
                    </b-form-group>
                </div>
            </div>
           <!-- v-if="funcionario.motorista==='1'" -->
            <div v-if="isMotorista===true">
                <hr>
                <h2 class="motorista-titulo">Dados do Motorista</h2>
                <div class="row">
                    <div class="col-md-2">
                        <b-form-group label="CNH:" label-for="funcionario-cnh">
                            <b-form-input id="funcionario-cnh" type="text"
                                v-model="funcionario.cnh"
                                placeholder="Informe a CNH"
                                :class="{ 'inputError': $v.funcionario.cnh.$error }"
                                class="textInput"
                            @keydown.tab="$v.funcionario.cnh.$touch"/>
                        <span class="error" v-if="!$v.funcionario.cnh.required && $v.funcionario.cnh.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.cnh.minLength && $v.funcionario.cnh.$error">Digite uma CNH válida!</span>
                        </b-form-group>
                    </div>
                    <div class="col-md-2">
                        <b-form-group label="CPF:" label-for="funcionario-cpf">
                            <b-form-input id="funcionario-cpf" type="text"
                                v-model="funcionario.cpf"
                                placeholder="Informe o CPF"
                                v-mask="'###.###.###-##'"
                                :class="{ 'inputError': $v.funcionario.cpf.$error }"
                                class="textInput"
                            @keydown.tab="$v.funcionario.cpf.$touch"/>
                        <span class="error" v-if="!$v.funcionario.cpf.required && $v.funcionario.cpf.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.cpf.minLength && $v.funcionario.cpf.$error">Digite um CPF válido!</span>
                        </b-form-group>
                    </div>
                    <div class="col-md-2">
                        <b-form-group label="RG:" label-for="funcionario-rg">
                            <b-form-input id="funcionario-rg" type="text"
                                v-model="funcionario.rg"
                                placeholder="Informe o RG"
                                v-mask="['##.###.###-#', '#.###.###-#', '###.###.###-##']"
                                :class="{ 'inputError': $v.funcionario.rg.$error }"
                                class="textInput"
                            @keydown.tab="$v.funcionario.rg.$touch"/>
                        <span class="error" v-if="!$v.funcionario.rg.required && $v.funcionario.rg.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.rg.minLength && $v.funcionario.rg.$error">Digite um RG válido!</span>
                        </b-form-group>
                    </div>
                    <div class="col-md-3">
                        <label for="funcionario-nascimento">Nascimento</label>
                        <b-form-input id="funcionario-nascimento"  type="date"
                            v-model="funcionario.nascimento" class="mb-2 textInput"
                            :class="{ 'inputError': $v.funcionario.nascimento.$error }" 
                            @keydown.tab="$v.funcionario.nascimento.$touch"/>
                        <span class="error" v-if="!$v.funcionario.nascimento.required && $v.funcionario.nascimento.$error">Campo Obrigatório!</span>
                    </div>
                    <div class="col-md-3">
                        <label for="funcionario-validade">Validade</label>
                        <b-form-input id="funcionario-validade" type="date"
                            v-model="funcionario.validade" class="mb-2 textInput"
                            :class="{ 'inputError': $v.funcionario.validade.$error }"
                            @keydown.tab="$v.funcionario.validade.$touch"/>
                        <span class="error" v-if="!$v.funcionario.validade.required && $v.funcionario.validade.$error">Campo Obrigatório!</span>
                    </div>
                </div>
                <hr>
                <h2 class="motorista-titulo">Dados do Veículo</h2>
                <div class="row">
                    <div class="col-md-4">
                        <b-form-group label="Placa:" label-for="funcionario-placa">
                            <b-form-input id="funcionario-placa" type="text"
                                v-model="funcionario.placa"
                                placeholder="Informe a Placa"
                                v-mask="customTokens"
                                :class="{ 'inputError': $v.funcionario.placa.$error }"
                                class="textInput"
                            @keydown.tab="$v.funcionario.placa.$touch"/>
                        <span class="error" v-if="!$v.funcionario.placa.required && $v.funcionario.placa.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.placa.minLength && $v.funcionario.placa.$error">Digite uma placa válida!</span>
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group label="Modelo do Veículo:" label-for="funcionario-modelo">
                            <b-form-input id="funcionario-modelo" type="text"
                                v-model="funcionario.modelo"
                                placeholder="Informe o modelo do veículo"
                                :class="{ 'inputError': $v.funcionario.modelo.$error }"
                                class="textInput"
                            @keydown.tab="$v.funcionario.modelo.$touch"/>
                        <span class="error" v-if="!$v.funcionario.modelo.required && $v.funcionario.modelo.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.funcionario.modelo.minLength && $v.funcionario.modelo.$error">Precisa ter no mínimo 3 letras!</span>
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group label="Capacidade de Carga:" label-for="funcionario-capacidade">
                            <b-form-input id="funcionario-capacidade" type="number" 
                                min="0" step="1"
                                v-model="funcionario.capacidade"
                                placeholder="Informe a capacidade"
                                :class="{ 'inputError': $v.funcionario.capacidade.$error }"
                                class="textInput"
                            @keydown.tab="$v.funcionario.capacidade.$touch"/>
                        <span class="error" v-if="!$v.funcionario.capacidade.required && $v.funcionario.capacidade.$error">Campo Obrigatório!</span>
                        </b-form-group>
                    </div>
                </div>
            </div>
            
            <b-button variant="outline-success" class="mb-3 botaoInput" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 mb-3 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'meFuncionarios',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            customTokens: {
                mask: 'CCC CCCC',
                tokens: {
                    'C': {
                        pattern: /[0-9a-zA-Z]/,
                        transform: function(v) {
                            return v.toLocaleUpperCase();
                        }
                    }
                }
            },
            jwt: new VueEasyJwt(),
            level: '',
            quemRecebeu: '',
            nome: '',
            email: '',
            ativar: [
                { value: '1', text: 'Sim' },
                { value: '0', text: 'Não' }
            ],
            ListaMotorista: [
                { value: '1', text: 'Sim' },
                { value: '0', text: 'Não' }
            ],
            ufs: [
                { value: 'AC', text: 'Acre' },
                { value: 'AL', text: 'Alagoas' },
                { value: 'AP', text: 'Amapa' },
                { value: 'AM', text: 'Amazonas' },
                { value: 'BA', text: 'Bahia' },
                { value: 'CE', text: 'Ceará' },
                { value: 'DF', text: 'Distrito Federal' },
                { value: 'ES', text: 'Espirito Santo' },
                { value: 'GO', text: 'Goiás' },
                { value: 'MA', text: 'Maranhão' },
                { value: 'MT', text: 'Mato Grosso' },
                { value: 'MS', text: 'Mato Grosso do Sul' },
                { value: 'MG', text: 'Minas Gerais' },
                { value: 'PA', text: 'Para' },
                { value: 'PB', text: 'Paraíba' },
                { value: 'PR', text: 'Paraná' },
                { value: 'PE', text: 'Pernambuco' },
                { value: 'PI', text: 'Piauí' },
                { value: 'RJ', text: 'Rio de Janeiro' },
                { value: 'RN', text: 'Rio Grande do Norte' },
                { value: 'RS', text: 'Rio Grande do Sul' },
                { value: 'RO', text: 'Rondônia' },
                { value: 'RR', text: 'Roraima' },
                { value: 'SC', text: 'Santa Catarina' },
                { value: 'SP', text: 'São Paulo' },
                { value: 'SE', text: 'Sergipe' },
                { value: 'TO', text: 'Tocantins' }
            ],
            funcionario: {},
            cargo: {},
            cargos: [],
            isMotorista: false
        }
    },
    computed: mapState(['user']),
    validations() {
        if (!this.isMotorista) {
            return {
                funcionario: {
                    nome: {
                        required,
                        minLength: minLength(4)
                    },
                    telefone: {
                        required,
                        minLength: minLength(10)
                    },
                    email: {
                        required,
                        email
                    },
                    cep: {
                        required,
                        minLength: minLength(8)
                    },
                    ativo: {
                        required
                    },
                    motorista: {
                        required
                    },
                    cidade: {
                        required
                    },
                    uf: {
                        required
                    },
                    logradouro: {
                        required,
                        minLength: minLength(4)
                    },
                    numero: {
                        required
                    }
                }
            }
        } else {
            return {
                funcionario: {
                    nome: {
                        required,
                        minLength: minLength(4)
                    },
                    telefone: {
                        required,
                        minLength: minLength(10)
                    },
                    email: {
                        required,
                        email
                    },
                    cep: {
                        required,
                        minLength: minLength(8)
                    },
                    ativo: {
                        required
                    },
                    motorista: {
                        required
                    },
                    cidade: {
                        required
                    },
                    uf: {
                        required
                    },
                    logradouro: {
                        required,
                        minLength: minLength(4)
                    },
                    numero: {
                        required
                    },
                    cnh: {
                        required,
                        minLength: minLength(3)
                    },
                    cpf: {
                        required,
                        minLength: minLength(10)
                    },
                    rg: {
                        required,
                        minLength: minLength(8)
                    },
                    nascimento: {
                        required
                    },
                    validade: {
                        required
                    },
                    placa: {
                        required,
                        minLength: minLength(7)
                    },
                    modelo: {
                        required,
                        minLength: minLength(3)
                    },
                    capacidade: {
                        required
                    }
                }
            }
        }
    },
    methods: {
        searchCep () {
            this.$v.funcionario.cep.$touch()
			if(this.funcionario.cep.length == 9) {
				axios.get(`https://viacep.com.br/ws/${ this.funcionario.cep }/json/`)
                .then( res => {
                    this.funcionario.cidade = res.data.localidade
                    this.funcionario.logradouro = res.data.logradouro
                    this.funcionario.uf = res.data.uf
                    document.getElementById("funcionario-logradouro").value = res.data.logradouro
                    document.getElementById("funcionario-UF").value = res.data.uf
                    document.getElementById("funcionario-cidade").value = res.data.localidade
                    document.getElementById("funcionario-numero").focus()
                })
				.catch( error => console.log(error) )
			} else {
                document.getElementById("funcionario-logradouro").value = ''
                document.getElementById("funcionario-UF").value = ''
                document.getElementById("funcionario-cidade").value = ''
            }
		},
        showMotorista() {
            if(document.getElementById('funcionario-motorista').value == '1') {
                this.isMotorista = true
            } else {
                this.isMotorista = false
            }
        },
        loadFuncionarios() {
            const url = `${baseApiUrl}/backend/funcionarios.php?id=${this.quemRecebeu}`
            axios.get(url).then(res => {
                this.funcionario = res.data[0]
                if (this.funcionario.motorista === '1'){
                    this.isMotorista = true
                } else {
                    this.isMotorista = false
                }
            })
        },
        reset() {
            this.funcionario = {}
            this.loadFuncionarios()
            this.isMotorista = false
            this.funcionario.cidade = ''
            this.funcionario.logradouro = ''
            this.funcionario.uf = ''
            document.getElementById("funcionario-logradouro").value = ''
            document.getElementById("funcionario-UF").value = ''
            document.getElementById("funcionario-cidade").value = ''
            this.$v.funcionario.$reset()
        },
        save() {
            this.$v.funcionario.$touch()
            if(!this.$v.funcionario.$error){
                axios['put'](`${baseApiUrl}/backend/funcionarios.php?id=${this.quemRecebeu}`, this.funcionario)
                    .then(() => {
                        const tipo = `?tipo=alteraFuncionario`
                        const destinoEmail = `&destinoEmail=${this.email}`
                        const destinoNome = `&destinoNome=${this.nome}`
                        axios.get(`${baseApiUrl}/backend/mailFuncionario.php${tipo}${destinoEmail}${destinoNome}`).then({})

                        this.$toasted.global.defaultSuccess({ message : 'Funcionário alterado com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
        this.loadFuncionarios()
        this.showMotorista()
    }
}
</script>

<style>
.textInput {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

label {
    font-size: 0.8rem;
}

.motorista-titulo {
        color: #777;
        margin-top: 5px;
        font-size: 1.3rem;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border-bottom: 1px solid #f57f6c !important;
}
</style>